import React from "react";
import Navbar from "../../Navbar/Navbar";
import jobs from "../../../utils/jobs";
import skills from "../../../utils/skills";
import download from "../../../img/download.svg";
import cv from "../../../utils/cv.pdf";
const CV = () => {
	return (
		<div>
			<Navbar />
			<div className="cv-container">
				<main>
					<section className="left">
						<h1>Jose Eduardo Vazquez Cortez</h1>
						<p className="job_description">Software engineer</p>
						<h2>Professional experience</h2>
						<div className="profesional_expirience">
							{jobs.reverse().map((job) => (
								<div className="job">
									<h2> {job.job_title}</h2>
									<p className="position">{job.company.toUpperCase()}</p>
									<div className="date">
										<p>{job.start_date}</p>
										<p>to</p>
										<p>{job.end_date}</p>
									</div>
									<div className="description">
										<p>{job.description}</p>
									</div>
								</div>
							))}
						</div>
					</section>
					<section className="right">
						<div className="education">
							<h2>Education</h2>
							<div className="school">
								<h3>Computation Bachelors Degree</h3>
							</div>
							<div className="skills">
								<h2>Skills</h2>
								<div className="skills_list">
									{skills.map((skill) => (
										<div className={`skill sk-${skill.id}`}>
											<h3>{skill.name}</h3>
											<div className="skill_percentage">
												<span>{skill.level}%</span>
												<div className="skill_level">
													<div
														className="skill_level_bar"
														style={{ width: `${skill.level}%` }}></div>
												</div>
											</div>
										</div>
									))}
								</div>
							</div>
						</div>
					</section>
				</main>
				<footer className="footer">
					<a href={cv} download className="download_cv">
						<p>Download my CV </p>
						<img src={download} alt="" />
					</a>
				</footer>
			</div>
		</div>
	);
};

export default CV;
